import React from 'react';

interface ITenderTypeButtonProps {
  selected?: boolean;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  fullWidth?: boolean;
  dataTestid?: string;
}

export const TenderTypeButton = ({
  selected,
  children,
  onClick,
  fullWidth,
  dataTestid,
}: ITenderTypeButtonProps) => {
  return (
    <div
      className={`sui-inline-block sui-relative ${
        fullWidth ? 'sui-w-full' : 'sui-w-fit'
      }`}
    >
      <button
        data-testid={dataTestid}
        onClick={onClick}
        type="button"
        className={`sui-btn sui-h-12 ${
          fullWidth ? 'sui-w-full' : 'sui-w-fit'
        } sui-px-3 sui-border-solid sui-border-1 sui-text-primary sui-text-base sui-leading-normal sui-tracking-normal sui-normal-case sui-line-clamp-none ${
          selected
            ? 'sui-font-bold sui-shadow-base sui-border-accent'
            : 'sui-font-regular sui-border-primary'
        }`}
      >
        {children}
      </button>
      {selected && (
        <div className="sui-absolute sui-right-0 sui-top-0">
          <svg
            width="27"
            height="25"
            viewBox="0 0 27 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.713867 0H26.9996V25L0.713867 0Z"
              fill="#F96302"
            />
            <g clipPath="url(#clip0_945_45797)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.6025 8.05461L16.833 6.71822L18.5394 8.50008L21.9727 4.85156L23.2525 6.18787L18.5598 11.1516L15.6025 8.05461Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_945_45797">
                <rect
                  width="9.14286"
                  height="8"
                  fill="white"
                  transform="translate(14.4277 4)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      )}
    </div>
  );
};
